// removed by extract-text-webpack-plugin
module.exports = {"lendersContainer":"lendersContainer__33bfi","lenderImage":"lenderImage__3rkU3"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVD/whiteLenders/style.css
// module id = WJKk
// module chunks = 458